import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProposalModel, ProposalEditPayload } from '../models/app.models';

@Injectable({
  providedIn: 'root'
})
export class ProposalService {
  private apiUrl = '/api/proposals';

  constructor(private http: HttpClient) {
  }

  /**
   * Délka vráceného pole = počet čekajících (Pending) návrhů. Odznak schránky "Asistentka"
   * v sidebaru kombinuje toto s otevřenými úkoly — viz AssistantBadgeService (dřív žil
   * pendingCount$/refreshPendingCount přímo tady, přesunuto při sjednocení s úkoly).
   */
  getQueue(): Observable<ProposalModel[]> {
    return this.http.get<ProposalModel[]>(this.apiUrl);
  }

  /** Schválí návrh; volitelný `linkToTransferId` napojí návrh na existující přestup místo založení nového. */
  approve(id: number, linkToTransferId?: number | null): Observable<ProposalModel> {
    return this.http.post<ProposalModel>(`${this.apiUrl}/${id}/approve`, { linkToTransferId: linkToTransferId ?? null });
  }

  edit(id: number, model: ProposalEditPayload): Observable<ProposalModel> {
    return this.http.post<ProposalModel>(`${this.apiUrl}/${id}/edit`, model);
  }

  /** Zamítne návrh; volitelný důvod se uloží k rozhodnutí (podklad pro učení AI asistentky). */
  reject(id: number, reason?: string | null): Observable<ProposalModel> {
    return this.http.post<ProposalModel>(`${this.apiUrl}/${id}/reject`, { reason: reason ?? null });
  }
}
